// extracted by mini-css-extract-plugin
export default {"workerCards":"TeamWorkerReassign_workerCards__z52XQ","select":"TeamWorkerReassign_select__611TO"};